// Formato unificado del número de factura emitida en toda la app (roadmap 1.4):
// "SERIE-NNNN" con el número a 4 cifras ("2026-0001"), el mismo que el backend
// (utils/invoicing.format_invoice_label) usa en PDF, emails y asientos.
export function formatInvoiceLabel(series, number) {
  const s = (series ?? "").toString().trim();
  const n = Number(number);
  const num = Number.isInteger(n) && number !== null && number !== ""
    ? String(n).padStart(4, "0")
    : String(number ?? "");
  if (s && num) return `${s}-${num}`;
  return s || num;
}
